import React, { useState } from "react";
import { JdsButton } from "../../../components/jds/JdsButton";
import { ClienteModal, AlertIcon } from "./clienteUi";

export default function CancelModal({ setOpen, onConfirm }) {
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState("");
  const [error, setError] = useState("");

  const handleConfirm = async () => {
    if (!reason.trim()) {
      setError("O motivo do cancelamento é obrigatório.");
      return;
    }
    setError("");
    setIsLoading(true);
    try {
      await onConfirm(reason);
    } finally {
      setIsLoading(false);
    }
  };

  const handlerDismiss = () => {
    setOpen(false);
  };

  return (
    <ClienteModal
      icon={<AlertIcon />}
      title="Cancelar assinatura"
      description="Tem certeza que deseja cancelar a assinatura?"
      actions={
        <>
          <JdsButton
            variant="outlined"
            color="neutral"
            onClick={() => handlerDismiss()}
            disabled={isLoading}
          >
            Não
          </JdsButton>
          <JdsButton color="error" onClick={handleConfirm} disabled={isLoading}>
            {isLoading ? "Cancelando..." : "Sim, cancelar"}
          </JdsButton>
        </>
      }
    >
      <textarea
        className="form-control"
        placeholder="Motivo do cancelamento"
        aria-label="Motivo do cancelamento"
        value={reason}
        onChange={e => setReason(e.target.value)}
        rows={3}
        disabled={isLoading}
      />
      {error && <div className="text-danger mt-2">{error}</div>}
    </ClienteModal>
  );
}
